import type { TypedMyBrandSectionHeader } from './-MyBrandSectionHeader';
import RawMyBrandSectionHeader from './MyBrandSectionHeader.vue';
export * from './-MyBrandSectionHeader';
export const MyBrandSectionHeader = RawMyBrandSectionHeader as typeof TypedMyBrandSectionHeader;
